module.exports = __webpack_public_path__ + "static/18-e5414cb54857602d0e0b7ddf9e3bdcef.png";